import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "color-picker",
  templateUrl: "./color-picker.component.html",
  styleUrls: ["./color-picker.component.scss"]
})
export class ColorPickerComponent {
  @Input() colorValue: string;

  @Input() labelText = "LABEL";
  @Input() labelClasses: string;
  @Input() labelStyles: string;

  @Input() colorPickerId = "COLOR_PICKER_ID";
  @Input() colorPickerClasses: string;
  @Input() colorPickerStyles: string;


  @Output() colorPicked = new EventEmitter<{ color: string; id: string }>();

  handleColorChange(colorChangedEvent: Event) {
    const colorPickerElement = colorChangedEvent.target as HTMLInputElement;
    this.colorPicked.emit({ color: colorPickerElement.value, id: this.colorPickerId });
  }
}
